let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jAOus")).then(() => parcelRequire('aBLo2'));